export default "__VITE_ASSET__B3sBnQ60__"